import Vue from 'vue'
export const GlobalEmitter = new Vue()